import Api from '../api'

export default ({

  state: {
    eventRegistrationReports: []
  },
  mutations: {
    ADD_REGISTRATION (state, eventRegistrationReports) {
      let eventRegistrationReport = state.eventRegistrationReports.concat(eventRegistrationReports)
    //   console.log(itemgroup)
      state.eventRegistrationReports = eventRegistrationReport
    //   console.log(state.itemgroups)
    },
    SET_EVENT_REGISTRATION (state, eventRegistrationReport) {
      state.eventRegistrationReports = eventRegistrationReport
    }
  },
  actions: {
    async registerEvent({commit}, event) {
      let response = await Api.request('post', '/eventManagement/saveEventManagement', event)
      let savedSalesBillSundry = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_REGISTRATION', savedSalesBillSundry)
      }
      return response
    },
    async loadEventRegisterReport({commit}) {
      let response = await Api.request('get', '/eventManagement/eventManagementList', null)
      commit('SET_EVENT_REGISTRATION', response.data.data)
      return response
    }
  },
  getters: {

  }
})



// WEBPACK FOOTER //
// ./src/store/eventManagement.js